/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
/* Palo Alto – Custom JS */
(function () {

  // ===== Detect mega menu open state =====
  const body = document.body;

  function updateMenuState() {
    const isOpen = document.querySelector(
      '.mega-menu.is-open, .mega-menu.is-visible, .header__submenu.is-open, .header__menu-dropdown.is-open, [aria-expanded="true"]'
    );

    body.classList.toggle('gymset-menu-open', !!isOpen);
  }

  // Observe DOM changes
  const observer = new MutationObserver(updateMenuState);
  observer.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-expanded']
  });

  // Fallback events
  document.addEventListener('mouseover', updateMenuState);
  document.addEventListener('click', updateMenuState);
  document.addEventListener('keyup', updateMenuState);

})();

/* GYMSET – Mobile product gallery */
(function () {
  const MOBILE_MAX = 767;

  function initGymsetGallery() {
    if (window.innerWidth > MOBILE_MAX) return;

    document
      .querySelectorAll('[data-product-single-media-group]')
      .forEach(function (gallery) {

        const slider = gallery.querySelector(
          '[data-product-single-media-slider]'
        );

        if (!slider || slider.dataset.gymsetGallery === 'true') return;

        const slides = slider.querySelectorAll(
          '[data-product-single-media-wrapper]'
        );

        if (slides.length < 2) return;

        slider.dataset.gymsetGallery = 'true';

        /* Create pagination */
        const pagination = document.createElement('div');
        pagination.className = 'gymset-gallery-pagination';

        /* Counter */
        const counter = document.createElement('div');
        counter.className = 'gymset-gallery-counter';
        counter.innerHTML =
          '<span class="gymset-gallery-current">1</span>/' + slides.length;

        /* Dots */
        const dotsWrapper = document.createElement('div');
        dotsWrapper.className = 'gymset-gallery-dots';

        slides.forEach(function (_, index) {
          const dot = document.createElement('span');
          dot.className =
            'gymset-gallery-dot' + (index === 0 ? ' is-active' : '');

          dotsWrapper.appendChild(dot);
        });

        pagination.appendChild(counter);
        pagination.appendChild(dotsWrapper);
        gallery.appendChild(pagination);

        const current = counter.querySelector('.gymset-gallery-current');
        const dots = dotsWrapper.querySelectorAll('.gymset-gallery-dot');

        function updatePagination() {
          let selectedIndex = 0;

          slides.forEach(function (slide, index) {
            if (slide.classList.contains('is-selected')) {
              selectedIndex = index;
            }
          });

          current.textContent = selectedIndex + 1;

          dots.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === selectedIndex);
          });
        }

        /* Watch Flickity slide changes */
        const observer = new MutationObserver(updatePagination);

        slides.forEach(function (slide) {
          observer.observe(slide, {
            attributes: true,
            attributeFilter: ['class']
          });
        });

        updatePagination();
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initGymsetGallery, 500);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initGymsetGallery, 500);
  });
})();